import script from "./BaseTableBackendFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTableBackendFilter.vue?vue&type=script&setup=true&lang=js"

import "./BaseTableBackendFilter.vue?vue&type=style&index=0&id=76d8bdee&scoped=true&lang=css"

import exportComponent from "/workspace/www/web/public/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d8bdee"]])

export default __exports__